var $35da740d59af89ba$exports = {};
let $35da740d59af89ba$var$map;
const $35da740d59af89ba$var$provinces = {
    "ChIJI9kl2-8udTERFHIryt1Uz0s": 22,
    "ChIJoVmP1vLDdjERjsI0345CNyc": 6,
    "ChIJIY5foglSoDERTgqWSmqWc9Y": 6,
    "ChIJj-0MGk4XoDERE4o57BhuS7c": 5,
    "ChIJeSj5jmq2dDERcxSNHInanzM": 5,
    "ChIJs2mi7ZHyoDER5dn-Lulyo3k": 5,
    "ChIJez-heqBJoTERs-aysVPn-a8": 7,
    "ChIJDb3qxxupmDERT8bH4BD4NO8": 4,
    "ChIJzXUakhzaCTERevNfMyZB54c": 9,
    "ChIJn6e8DFyoCjERQ3UxZ-VUPKo": 1,
    "ChIJjSriTooZCjERuojAUiywHNw": 11,
    "ChIJfdvzWSYTcTERbPVUX9_SWrs": 14,
    "ChIJeUgqlTy2CjERI0HFz5nt6ts": 0,
    "ChIJMXJO1JFCCzERzWzchde8giQ": 3,
    "ChIJE45EIbybCjERpXVcaT5qxlI": 4,
    "ChIJHxIM1bNlCjERQG40rV7JoNw": 11,
    "ChIJQ44uKJxsdTERUu3qQZlT48w": 2,
    "ChIJJepKuFLZdDERVRZuS_HmSuA": 3,
    "ChIJgSaoteuvCjERdWM3wQen4zw": 5,
    "ChIJzYJzkp9ioDERZ-wJEdljpHI": 8,
    "ChIJ8_vR4A4fLTER9A7fYoWMcUg": 0,
    "ChIJUbTROSwyLTERLjxIkWCRKeI": 0,
    "ChIJBw5Mv4w7zTYRaJBG-7m2oiE": 0,
    "ChIJbyVFtz5UtTYRWm6Chdo0Pfo": 0,
    "ChIJ4R5JpfutNDERf3iEknEBVH8": 0,
    "ChIJTeuFSkjgyjYR0G5JK0iQA78": 0,
    "ChIJsXHT6sp5zDYRqIDLmrB4SIM": 0,
    "ChIJ52dYYbZcyjYRWFR2N_RyN2U": 0,
    "ChIJ1R093JBZMjERezgPalpkLVg": 0,
    "ChIJGStwEvU5MzERteIKRp__AAU": 0,
    "ChIJd3qgchjENDERW0_vaRA3qVc": 0,
    "ChIJKfEdqqvkQDERKE3VIOD6ceQ": 0,
    "ChIJ_65MY79wbzERgBoXHBy-bv4": 3,
    "ChIJ-zyQ3XmDNDERbmTIyOCN7DA": 0,
    "ChIJcwkWqew-aDERse05Mm6NoU0": 3,
    "ChIJwcgQb6twNjERLQwTPE5T5W0": 0,
    "ChIJmZJ2447GNjERT_urFvXeeAE": 0,
    "ChIJXSYdMDWvNTERgtTWzxbqqac": 0,
    "ChIJLW8pOPawODERj1kjYi6HH5A": 0,
    "ChIJ95BkcoecQTERtYTL98oPHKs": 7,
    "ChIJM3A59dPkNTERx1sdOPgF5Go": 0,
    "ChIJL4V4mtcBSzERaoal8PR5B-0": 0,
    "ChIJJ6lE5uy1czERrYej9DDhMHU": 2,
    "ChIJKQqAE44ANTERDbkQYkF-mAI": 4,
    "ChIJUXqvJl0KNTERcI9VxsAgWeU": 0,
    "ChIJvxtxbu8tbzERN_3lOgRMv0U": 4,
    "ChIJrwn6F26VcDERRZ6Odp6S9fg": 4,
    "ChIJo4EvAoIfbDERDbVDgfa1Uow": 2,
    "ChIJb9jgnBgUNDERF_4UZiqEJag": 0,
    "ChIJ4WQZGBHFNTERUmgyOw25qXQ": 0,
    "ChIJ7c9Gs6kQNTERyFDrUFtMQjw": 0,
    "ChIJV3Ew99r3cTERFTOI2ZR2-Y4": 2,
    "ChIJ3xtSUSEMNjERYt8l_r-i68g": 1,
    "ChIJx8Pp7qEoODERaxB9uCZ7xxo": 0,
    "ChIJrR1aC2TOOTERGaUZ13y_YVw": 0,
    "ChIJJzcV2WViSjERPPfF4sM-Mpk": 0,
    "ChIJldPcqIwbcDERzggjMicIwmk": 9,
    "ChIJezo14dQNQjEReXZ0ZrGrnOQ": 3,
    "ChIJuy3qgk3lNDERXxAb4T-O0MA": 0,
    "ChIJNVLgSPR6SjERU5AdBNFX6YI": 0,
    "ChIJ39GqWCPnazERVIrYzKoRm2E": 2,
    "ChIJEyolkscZQjERBn5yhkvL8B0": 5,
    "ChIJHyJ92y9oczEREUL4cg4bwJQ": 2
};
const $35da740d59af89ba$var$post_offices = [
    [
        "AN GIANG",
        "B\u01AFU C\u1EE4C BX CH\xc2U \u0110\u1ED0C",
        "QL91, V\u0129nh M\u1EF9, Ch\xe2u \u0110\u1ED1c, Ch\xe2u Ph\xfa B, TP.Ch\xe2u \u0110\u1ED1c",
        10.6948897,
        105.1342876,
        1
    ],
    [
        "AN GIANG",
        "B\u01AFU C\u1EE4C BX LONG XUY\xcaN",
        "392 Ph\u1EA1m C\u1EF1 L\u01B0\u1EE3ng, P.M\u1EF9 Qu\xfd, TP.Long Xuy\xean",
        10.3590362,
        105.4242561,
        1
    ],
    [
        "AN GIANG",
        "B\u01AFU C\u1EE4C C\xc1I D\u1EA6U",
        "S\u1ED1 73, t\u1ED5 5, \u1EA5p B\xecnh Ch\xe1nh, x\xe3 B\xecnh Long, huy\u1EC7n Ch\xe2u Ph\xfa, t\u1EC9nh An Giang",
        10.5658076,
        105.2466482,
        1
    ],
    [
        "AN GIANG",
        "B\u01AFU C\u1EE4C CH\u1EE2 CH\xc2U \u0110\u1ED0C",
        "66 \u0110.Nguy\u1EC5n H\u1EEFu C\u1EA3nh - Kh\xf3m 5 - P.Ch\xe2u Ph\xfa A - Tp.Ch\xe2u \u0110\u1ED1c - T\u1EC9nh An Giang.",
        10.7097702,
        105.1181293,
        1
    ],
    [
        "B\xc0 R\u1ECAA V\u0168NG T\xc0U",
        "B\u01AFU C\u1EE4C 186 X\xd4 VI\u1EBET NGH\u1EC6 T\u0128NH",
        "186 X\xf4 Vi\u1EBFt Ngh\u1EC7 T\u0129nh, P. Th\u1EAFng Tam",
        10.350773,
        107.0841203,
        1
    ],
    [
        "B\xc0 R\u1ECAA V\u0168NG T\xc0U",
        "B\u01AFU C\u1EE4C B\xc0 R\u1ECAA",
        "QL51, T\u1ED5 10, KP2, P.Ph\u01B0\u1EDBc Trung, TP.B\xe0 R\u1ECBa",
        10.4907881,
        107.165575,
        1
    ],
    [
        "B\u1EA0C LI\xcaU",
        "B\u01AFU C\u1EE4C B\u1EA0C LI\xcaU",
        "B\u1EBFn xe B\u1EA1c Li\xeau, \u0110\u01B0\u1EDDng Tr\u1EA7n Ph\xfa, Qu\u1ED1c l\u1ED9 1A, Kh\xf3m 2, Ph\u01B0\u1EDDng 7, Th\xe0nh Ph\u1ED1 B\u1EA1c Li\xeau, T\u1EC9nh B\u1EA1c Li\xeau",
        9.3029078,
        105.7177586,
        1
    ],
    [
        "B\u1EA0C LI\xcaU",
        "B\u01AFU C\u1EE4C H\xd2A B\xccNH - B\u1EA0C LI\xcaU",
        "617 QL 1A, TT H\xf2a B\xecnh, Huy\u1EC7n H\xf2a B\xecnh, T\u1EC9nh B\u1EA1c Li\xeau",
        9.2800511,
        105.6179127,
        1
    ],
    [
        "B\u1EA0C LI\xcaU",
        "B\u01AFU C\u1EE4C H\u1ED8 PH\xd2NG - B\u1EA0C LI\xcaU",
        "Qu\u1ED1c l\u1ED91A, \u1EA4p 1, Th\u1ECB Tr\u1EA5n H\u1ED9 Ph\xf2ng, Huy\u1EC7n Gi\xe1 Rai, T\u1EC9nh B\u1EA1c Li\xeau",
        9.2358945,
        105.4127109,
        1
    ],
    [
        "B\u1EBEN TRE",
        "B\u01AFU C\u1EE4C B\u1EBEN TRE",
        "V\xf5 Nguy\xean Gi\xe1p, \u1EA4p 1, X.S\u01A1n \u0110\xf4ng, TP.B\u1EBFn Tre",
        10.2551962,
        106.3563806,
        1
    ],
    [
        "B\xccNH D\u01AF\u01A0NG",
        "B\u01AFU C\u1EE4C B\u1EBEN C\xc1T - B\xccNH D\u01AF\u01A0NG",
        "213 \u0110\u01B0\u1EDDng D11, Ph\u01B0\u1EDDng Th\u1EDBi Ho\xe0, Th\u1ECB X\xe3 B\u1EBFn C\xe1t, B\xecnh D\u01B0\u01A1ng",
        11.1246597,
        106.5993749,
        1
    ],
    [
        "B\xccNH D\u01AF\u01A0NG",
        "B\u01AFU C\u1EE4C B\u1EBEN XE B\xccNH D\u01AF\u01A0NG",
        "\u0110\u01B0\u1EDDng 30/04, Ph\u01B0\u1EDDng Ch\xe1nh Ngh\u0129a, TP. Th\u1EE7 D\u1EA7u M\u1ED9t, T\u1EC9nh B\xecnh D\u01B0\u01A1ng",
        10.9663794,
        106.5919233,
        1
    ],
    [
        "B\xccNH D\u01AF\u01A0NG",
        "B\u01AFU C\u1EE4C B\xccNH D\u01AF\u01A0NG",
        "110  Hu\u1EF3nh V\u0103n L\u0169y, Ph\u01B0\u1EDDng Ph\xfa L\u1EE3i, Th\u1EE7 D\u1EA7u M\u1ED9t, B\xecnh D\u01B0\u01A1ng",
        10.9891379,
        106.6703572,
        1
    ],
    [
        "B\xccNH D\u01AF\u01A0NG",
        "B\u01AFU C\u1EE4C D\u0128 AN - B\xccNH D\u01AF\u01A0NG",
        "269 \u0110\u01B0\u1EDDng L\xea H\u1ED3ng Phong, Khu ph\u1ED1 \u0110\xf4ng Chi\xeau, Ph\u01B0\u1EDDng T\xe2n \u0110\xf4ng Hi\u1EC7p, TP D\u0129 An, T\u1EC9nh B\xecnh D\u01B0\u01A1ng",
        10.9235311,
        106.7244576,
        1
    ],
    [
        "B\xccNH D\u01AF\u01A0NG",
        "B\u01AFU C\u1EE4C L\xc1I THI\xcaU - B\xccNH D\u01AF\u01A0NG",
        "Qu\u1ED1c l\u1ED9 13, P. L\xe1i Thi\xeau, TP Thu\u1EADn An, B\xecnh D\u01B0\u01A1ng",
        10.9063222,
        106.6361425,
        1
    ],
    [
        "B\xccNH \u0110\u1ECANH",
        "B\u01AFU C\u1EE4C 207 T\xc2Y S\u01A0N",
        "207 T\xe2y S\u01A1n, P.Quang Trung, TP.Quy Nh\u01A1n, T\u1EC9nh B\xecnh \u0110\u1ECBnh",
        13.7600227,
        109.2017472,
        1
    ],
    [
        "B\xccNH \u0110\u1ECANH",
        "B\u01AFU C\u1EE4C BX QUY NH\u01A0N",
        "VP Ph\u01B0\u01A1ng Trang, B\u1EBFn Xe Quy Nh\u01A1n, p.Gh\u1EC1nh R\xe1ng, TP. Quy Nh\u01A1n",
        13.7532627,
        109.2063641,
        1
    ],
    [
        "B\xccNH \u0110\u1ECANH",
        "PGD AN NH\u01A0N - B\xccNH \u0110\u1ECANH",
        "S\u1ED1 2 \u0110\u01B0\u1EDDng Nguy\u1EC5n V\u0103n Linh, Kh\u1ED1i V\u0129nh Li\xeam, P. B\xecnh \u0110\u1ECBnh, Th\u1ECB x\xe3 An Nh\u01A1n",
        13.8890841,
        109.1186601,
        1
    ],
    [
        "B\xccNH THU\u1EACN",
        "B\u01AFU C\u1EE4C M\u0168I N\xc9 - BT",
        "141  Hu\u1EF3nh Th\xfac Kh\xe1ng, P.M\u0169i N\xe9, TP.Phan Thi\u1EBFt, T\u1EC9nh B\xecnh Thu\u1EADn",
        10.942119,
        108.2760139,
        1
    ],
    [
        "B\xccNH THU\u1EACN",
        "B\u01AFU C\u1EE4C PHAN THI\u1EBET - BT",
        "B1 V\xf5 V\u0103n Ki\u1EC7t, Ph\xfa Th\u1EE7y, TP.Phan Thi\u1EBFt, T\u1EC9nh B\xecnh Thu\u1EADn",
        10.9402944,
        108.1030622,
        1
    ],
    [
        "C\xc0 MAU",
        "B\u01AFU C\u1EE4C B\u1EBEN XE C\xc0 MAU",
        "BX C\xe0 Mau, QL 1A, P. 6, TP. C\xe0 Mau, t\u1EC9nh C\xe0 Mau",
        9.1753865,
        105.1604918,
        1
    ],
    [
        "C\xc0 MAU",
        "B\u01AFU C\u1EE4C C\xc0 MAU",
        "221/19A1 L\xfd Th\u01B0\u1EDDng Ki\u1EC7t, P. 6, TP. C\xe0 Mau, t\u1EC9nh C\xe0 Mau",
        9.1738436,
        105.155617,
        1
    ],
    [
        "C\xc0 MAU",
        "B\u01AFU C\u1EE4C C\xc0 MAU",
        "210 L\xfd Th\u01B0\u1EDDng Ki\u1EC7t, P6, C\xe0 Mau Th\u1EEDa \u0111\u1EA5t s\u1ED1 275, t\u1EDD b\u1EA3n \u0111\u1ED3 s\u1ED1 32, Ph\u01B0\u1EDDng 6, TP. C\xe0 Mau)",
        9.173606,
        105.1890204,
        1
    ],
    [
        "C\xc0 MAU",
        "B\u01AFU C\u1EE4C \u0110\u1EA6M D\u01A0I - C\xc0 MAU",
        "Kh\xf3m 1, Th\u1ECB Tr\u1EA5n \u0110\u1EA7m D\u01A1i, Huy\u1EC7n \u0110\u1EA7m D\u01A1i, t\u1EC9nh C\xe0 Mau",
        9.0004432,
        105.1934832,
        1
    ],
    [
        "C\xc0 MAU",
        "B\u01AFU C\u1EE4C N\u0102M C\u0102N - C\xc0 MAU",
        "BX N\u0103m C\u0103n, Kh\xf3m C\xe1i Nai, TT.N\u0103m C\u0103n, H.N\u0103m C\u0103n, t\u1EC9nh C\xe0 Mau",
        8.7622138,
        104.9986173,
        1
    ],
    [
        "C\u1EA6N TH\u01A0",
        "B\u01AFU C\u1EE4C 13 PHAN \u0110\u0102NG L\u01AFU",
        "13 Phan \u0110\u0103ng L\u01B0u, P.Th\u1EDBi B\xecnh, Q.Ninh Ki\u1EC1u, C\u1EA7n Th\u01A1",
        10.044302,
        105.7777037,
        1
    ],
    [
        "C\u1EA6N TH\u01A0",
        "B\u01AFU C\u1EE4C 91B C\u1EA6N TH\u01A0",
        "38C Nguy\u1EC5n V\u0103n Linh, Ph\u01B0\u1EDDng H\u01B0ng L\u1EE3i, Qu\u1EADn Ninh Ki\u1EC1u, Th\xe0nh Ph\u1ED1 C\u1EA7n Th\u01A1",
        10.0242489,
        105.7590757,
        1
    ],
    [
        "C\u1EA6N TH\u01A0",
        "B\u01AFU C\u1EE4C C\xc1I R\u0102NG",
        "BX Kh\xe1ch Trung t\xe2m TP, P.H\u01B0ng Th\u1EA1nh, Q.C\xe1i R\u0103ng, C\u1EA7n Th\u01A1",
        10.0060666,
        105.7694997,
        1
    ],
    [
        "C\u1EA6N TH\u01A0",
        "B\u01AFU C\u1EE4C \xd4 M\xd4N",
        "Khu v\u1EF1c 5, P.Ch\xe2u V\u0103n Li\xeam, Q.\xd4 M\xf4n, C\u1EA7n Th\u01A1",
        10.1085973,
        105.615931,
        1
    ],
    [
        "C\u1EA6N TH\u01A0",
        "B\u01AFU C\u1EE4C PHONG \u0110I\u1EC0N",
        "133 PHAN V\u0102N TR\u1ECA, TT. PHONG \u0110I\u1EC0N, H. PHONG \u0110I\u1EC0N, C\u1EA6N TH\u01A0",
        9.9965169,
        105.6624505,
        1
    ],
    [
        "C\u1EA6N TH\u01A0",
        "B\u01AFU C\u1EE4C TH\u1ED0T N\u1ED0T",
        "Khu v\u1EF1c Qui Th\u1EA1nh 1, P.Trung Ki\xean, Q.Th\u1ED1t N\u1ED1t, C\u1EA7n Th\u01A1",
        10.2497649,
        105.540334,
        1
    ],
    [
        "\u0110\xc0 N\u1EB4NG",
        "B\u01AFU C\u1EE4C 15 T\xda M\u1EE0 - \u0110\xc0 N\u1EB4NG",
        "15 T\xfa M\u1EE1, Ph\u01B0\u1EDDng H\xf2a An, Qu\u1EADn C\u1EA9m L\u1EC7, TP. \u0110\xe0 N\u1EB5ng",
        16.0531777,
        108.1737321,
        1
    ],
    [
        "\u0110\xc0 N\u1EB4NG",
        "B\u01AFU C\u1EE4C 16 TR\u1EA6N PH\xda \u0110.N\u1EB4NG",
        "16 Tr\u1EA7n Ph\xfa, \u0110\xe0 N\u1EB5ng Plaza, P Th\u1EA1ch Thang, Q H\u1EA3i Ch\xe2u, TP \u0110\xe0 N\u1EB5ng",
        16.0794155,
        108.1846131,
        1
    ],
    [
        "\u0110\xc0 N\u1EB4NG",
        "B\u01AFU C\u1EE4C 17 \u2013 18AH NAM TR\xc2N \u0110\xc0 N\u1EB4NG",
        "L\xf4 17 - 18AH Nam Tr\xe2n, P.H\xf2a Minh, Q.Li\xean Chi\u1EC3u, \u0110\xe0 N\u1EB5ng",
        16.0593111,
        108.1709661,
        1
    ],
    [
        "\u0110\xc0 N\u1EB4NG",
        "B\u01AFU C\u1EE4C 861 NG\xd4 QUY\u1EC0N - \u0110\xc0 N\u1EB4NG",
        "861 Ng\xf4 Quy\u1EC1n, Ph\u01B0\u1EDDng An H\u1EA3i \u0110\xf4ng, Qu\u1EADn S\u01A1n Tr\xe0",
        16.065953,
        108.2319192,
        1
    ],
    [
        "\u0110\xc0 N\u1EB4NG",
        "B\u01AFU C\u1EE4C 94 NGUY\u1EC4N TRI PH\u01AF\u01A0NG",
        "74 Nguy\u1EC5n Tri Ph\u01B0\u01A1ng, P.Chinh Gi\xe1n, Q.Thanh Kh\xea, TP.\u0110\xe0 N\u1EB5ng",
        16.0625002,
        108.2014057,
        1
    ],
    [
        "\u0110\u1EAEK L\u1EAEK",
        "B\u01AFU C\u1EE4C \u0110\u1EAEK L\u1EAEK",
        "172 L\xea Du\u1EA9n , TP Bu\xf4n M\xea Thu\u1ED9t",
        12.6652162,
        108.0345296,
        1
    ],
    [
        "\u0110\u1EAEK N\xd4NG",
        "B\u01AFU C\u1EE4C \u0110\u1EAEK N\xd4NG",
        "226 Hai B\xe0 Tr\u01B0ng (c\xe2y x\u0103ng H\u1ED3 V\u1ECBt), Th\u1ECB x\xe3 Gia Ngh\u0129a, \u0110\u0103k N\xf4ng",
        12.0028435,
        107.6808409,
        1
    ],
    [
        "\u0110\u1ED2NG NAI",
        "B\u01AFU C\u1EE4C 193 \u0110\u1ED2NG KH\u1EDEI",
        "2/18 Khu ph\u1ED1 6 (193 \u0110\u1ED3ng Kh\u1EDFi), P.Tam Hi\u1EC7p, TP Bi\xean H\xf2a",
        10.957418,
        106.8566849,
        1
    ],
    [
        "\u0110\u1ED2NG NAI",
        "B\u01AFU C\u1EE4C BI\xcaN H\xd2A",
        "D9, T\u1ED5 2, KP4, XLHN, P.Long B\xecnh, TP. Bi\xean H\xf2a",
        10.9707444,
        106.7923553,
        1
    ],
    [
        "\u0110\u1ED2NG TH\xc1P",
        "B\u01AFU C\u1EE4C B\u1EBEN XE CAO L\xc3NH",
        "Qu\u1ED1c l\u1ED9 30, \u1EA4p An \u0110\u1ECBnh, X\xe3 An B\xecnh, Huy\u1EC7n Cao L\xe3nh, \u0110\u1ED3ng Th\xe1p",
        10.448450,
        105.671285,
        1
    ],
    [
        "\u0110\u1ED2NG TH\xc1P",
        "B\u01AFU C\u1EE4C CAO L\xc3NH",
        "17-19 V\xf5 Th\u1ECB S\xe1u. Ph\u01B0\u1EDDng 2. Tp Cao L\xe3nh - \u0110\u1ED3ng Th\xe1p",
        10.448450,
        105.671285,
        1
    ],
    [
        "\u0110\u1ED2NG TH\xc1P",
        "B\u01AFU C\u1EE4C SA \u0110\xc9C",
        "149/8 Kh\xf3m H\xf2a Kh\xe1nh, P.2, TP.Sa \u0110\xe9c, \u0110\u1ED3ng Th\xe1p",
        10.2886334,
        105.7688894,
        1
    ],
    [
        "H\xc0 N\u1ED8I",
        "B\u01AFU C\u1EE4C 839 GI\u1EA2I PH\xd3NG",
        "839 Gi\u1EA3i Ph\xf3ng, P.Gi\xe1p B\xe1t, Q.Ho\xe0ng Mai, H\xe0 N\u1ED9i",
        20.9825531,
        105.838772,
        1
    ],
    [
        "H\xc0 N\u1ED8I",
        "B\u01AFU C\u1EE4C C\u1EA6U GI\u1EA4Y",
        "467 Nguy\u1EC5n Khang, P. Y\xean H\xf2a, Q. C\u1EA7u Gi\u1EA5y, H\xe0 N\u1ED9i",
        21.023283,
        105.7979442,
        1
    ],
    [
        "H\xc0 N\u1ED8I",
        "B\u01AFU C\u1EE4C H\xc0 N\u1ED8I",
        "BX Gi\xe1p B\xe1t, \u0111\u01B0\u1EDDng Gi\u1EA3i Ph\xf3ng, P.Ho\xe0ng Li\u1EC7t, Q.Ho\xe0ng Mai",
        20.9795399,
        105.8361944,
        1
    ],
    [
        "H\xc0 N\u1ED8I",
        "B\u01AFU C\u1EE4C V\u0128NH TUY",
        "KCN V\u0129nh Tuy, P. V\u0129nh H\u01B0ng, Q. Ho\xe0ng Mai, H\xe0 N\u1ED9i",
        20.9831638,
        105.8714005,
        1
    ],
    [
        "H\u1EACU GIANG",
        "B\u01AFU C\u1EE4C C\xc1I T\u1EAEC",
        "457 QL 1A,TT.C\xe1i T\u1EAFc, H.Ch\xe2u Th\xe0nh A, H\u1EADu Giang",
        9.9299945,
        105.7228076,
        1
    ],
    [
        "H\u1EACU GIANG",
        "B\u01AFU C\u1EE4C NG\xc3 7",
        "\u0110\u01B0\u1EDDng 3/2, khu v\u1EF1c 5, Ph\u01B0\u1EDDng Ng\xe3 7, Th\u1ECB X\xe3 Ng\xe3 7, H\u1EADu Giang. (BX m\u1EDBi Ng\xe3 7)",
        9.828089,
        105.808369,
        1
    ],
    [
        "H\u1EACU GIANG",
        "B\u01AFU C\u1EE4C V\u1ECA THANH",
        "BX V\u1ECB Thanh Qu\u1ED1c L\u1ED9 61C - \u0110\u01B0\u1EDDng n\u1ED1i V\u1ECB Thanh C\u1EA7n Th\u01A1, X\xe3 V\u1ECB Trung, Huy\u1EC7n V\u1ECB Th\u1EE7y, H\u1EADu Giang",
        9.7821254,
        105.4974922,
        1
    ],
    [
        "HU\u1EBE",
        "B\u01AFU C\u1EE4C 64 NGUY\u1EC4N TRI PH\u01AF\u01A0NG - HU\u1EBE",
        "64 Nguy\u1EC5n Tri Ph\u01B0\u01A1ng,  P. Ph\xfa H\u1ED9i, TP.Hu\u1EBF",
        16.465966857446833,
        107.59424978346821,
        1
    ],
    [
        "HU\u1EBE",
        "B\u01AFU C\u1EE4C BX PH\xcdA B\u1EAEC HU\u1EBE",
        "132 L\xfd Th\xe1i T\u1ED5, P.An H\xf2a, TP Hu\u1EBF",
        16.4860105,
        107.5083516,
        1
    ],
    [
        "HU\u1EBE",
        "B\u01AFU C\u1EE4C BX PH\xcdA NAM HU\u1EBE",
        "97 An D\u01B0\u01A1ng V\u01B0\u01A1ng, P. An \u0110\xf4ng, TP. Hu\u1EBF",
        16.4505376,
        107.5709283,
        1
    ],
    [
        "KI\xcaN GIANG",
        "B\u01AFU C\u1EE4C L\u1EA0C H\u1ED2NG",
        "65  L\u1EA1c H\u1ED3ng, KP2, P.V\u0129nh L\u1EA1c, TP.R\u1EA1ch Gi\xe1",
        9.9981223,
        105.0915896,
        1
    ],
    [
        "KI\xcaN GIANG",
        "B\u01AFU C\u1EE4C PHAN TH\u1ECA R\xc0NG",
        "L6\u201303 Phan Th\u1ECB R\xe0ng, P. An H\xf2a, TP. R\u1EA1ch Gi\xe1, Ki\xean Giang",
        9.9686571,
        105.1016238,
        1
    ],
    [
        "KI\xcaN GIANG",
        "B\u01AFU C\u1EE4C R\u1EA0CH GI\xc1",
        "260A Nguy\u1EC5n B\u1EC9nh Khi\xeam, P.V\u0129nh Quang, TP.R\u1EA1ch Gi\xe1, Ki\xean Giang",
        10.0211538,
        105.0708803,
        1
    ],
    [
        "KI\xcaN GIANG",
        "B\u01AFU C\u1EE4C R\u1EA0CH S\u1ECEI",
        "BX Ki\xean Giang, X.V\u0129nh H\xf2a Hi\u1EC7p, H.Ch\xe2u Th\xe0nh, Ki\xean Giang",
        9.9447851,
        105.1265598,
        1
    ],
    [
        "KH\xc1NH H\xd2A",
        "B\u01AFU C\u1EE4C 14 NGUY\u1EC4N \u0110\u1EE8C C\u1EA2NH - NHA TRANG",
        "14 Nguy\u1EC5n \u0110\u1EE9c C\u1EA3nh, ph\u01B0\u1EDDng Ph\u01B0\u1EDBc Long, Nha Trang",
        12.2162682,
        109.1916768,
        1
    ],
    [
        "KH\xc1NH H\xd2A",
        "B\u01AFU C\u1EE4C 151 NTMK - NHA TRANG",
        "151 Nguy\u1EC5n Th\u1ECB Minh Khai, Ph\u01B0\u1EDDng Ph\u01B0\u1EDBc H\xf2a",
        12.2356147,
        109.1835978,
        1
    ],
    [
        "KH\xc1NH H\xd2A",
        "B\u01AFU C\u1EE4C 168 NGUY\u1EC4N XI\u1EC2N - NHA TRANG",
        "168 Nguy\u1EC5n Xi\u1EC3n, T\u1ED5 5, Th\xf4n Li\xean Th\xe0nh , X\xe3 V\u0129nh Ph\u01B0\u01A1ng",
        12.303605,
        109.1697767,
        1
    ],
    [
        "KH\xc1NH H\xd2A",
        "B\u01AFU C\u1EE4C 176 TR\u1EA6N QU\xdd C\xc1P - NHA TRANG",
        "176 Tr\u1EA7n Qu\xfd C\xe1p, TP.Nha Trang",
        12.2516328,
        109.1683659,
        1
    ],
    [
        "KH\xc1NH H\xd2A",
        "B\u01AFU C\u1EE4C BX CAM RANH A",
        "BX Cam Ranh, 01 L\xea Du\u1EA9n, P.Cam L\u1ED9c, TP.Cam Ranh",
        11.9195215,
        109.1445072,
        1
    ],
    [
        "KH\xc1NH H\xd2A",
        "B\u01AFU C\u1EE4C BX NINH H\xd2A",
        "Qu\u1ED1c L\u1ED9 1A, Km 1421, T\u1ED5 D\xe2n ph\u1ED1 Thanh Ch\xe2u, P.Ninh Giang, TX Ninh H\xf2a,, T\u1EC9nh Kh\xe1nh H\xf2a",
        12.4769956,
        109.1267661,
        1
    ],
    [
        "KH\xc1NH H\xd2A",
        "B\u01AFU C\u1EE4C BX PH\xcdA B\u1EAEC NHA TRANG",
        "S\u1ED1 1 \u0110\u01B0\u1EDDng 2/4, P.V\u0129nh H\xf2a, Nha Trang(n\u1EB1m trong BX Ph\xeda B\u1EAFc Nha Trang)",
        12.2885428,
        109.1880267,
        1
    ],
    [
        "KH\xc1NH H\xd2A",
        "B\u01AFU C\u1EE4C DI\xcaN KH\xc1NH",
        "62 L\u1EA1c Long Qu\xe2n, TT.Di\xean Kh\xe1nh, H.Di\xean Kh\xe1nh",
        12.2572158,
        109.0920058,
        1
    ],
    [
        "KH\xc1NH H\xd2A",
        "B\u01AFU C\u1EE4C M\u1EF8 CA",
        "240 \u0110\u1EA1i l\u1ED9 H\xf9ng V\u01B0\u01A1ng, ph\u01B0\u1EDDng Cam Ngh\u0129a, Tp.Cam Ranh, Kh\xe1nh Ho\xe0",
        11.988826542347164,
        109.19184675753446,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C 186A NGUY\u1EC4N \u1EA2NH TH\u1EE6",
        "186A Nguy\u1EC5n \u1EA2nh Th\u1EE7, Ph\u01B0\u1EDDng Hi\u1EC7p Th\xe0nh, Q.12, HCM",
        10.877052,
        106.6402715,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C 215A B\u1EDC BAO T\xc2N TH\u1EAENG",
        "215A B\u1EDD Bao T\xe2n Th\u1EAFng, Ph\u01B0\u1EDDng S\u01A1n K\u1EF3, Qu\u1EADn T\xe2n Ph\xfa. HCM",
        10.7985892,
        106.6113697,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C 223 PH\u1EA0M H\u1EEEU L\u1EA6U",
        "223 Ph\u1EA1m H\u1EEFu L\u1EA7u, Ph\xfa M\u1EF9, Qu\u1EADn 7, HCM",
        10.7042113,
        106.7278382,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C 241 L\xca H\u1ED2NG PHONG",
        "241 - 249B L\xca H\u1ED2NG PHONG, PH\u01AF\u1EDCNG 4, QU\u1EACN 5 ,HCM",
        10.7598082,
        106.6747322,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C 288 \u0110\u1ED2NG \u0110EN",
        "288 \u0110\u1ED3ng \u0110en, P.10, Q.T\xe2n B\xecnh, HCM",
        10.7855571,
        106.6402984,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C 319 PH\u1EA0M NG\u0168 L\xc3O",
        "319 Ph\u1EA1m Ng\u0169 L\xe3o, P. Ph\u1EA1m Ng\u0169 L\xe3o, Q.1",
        10.7674786,
        106.6881638,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C 335 L\xca H\u1ED2NG PHONG",
        "335-337 L\xea H\u1ED3ng Phong, P.2, Q.10, TP.HCM",
        10.7747351,
        106.6623139,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C 358 NGUY\u1EC4N V\u0102N L\u01AF\u1EE2NG",
        "358 Nguy\u1EC5n V\u0103n L\u01B0\u1EE3ng, Ph\u01B0\u1EDDng 16, Qu\u1EADn G\xf2 V\u1EA5p, HCM",
        10.8387409,
        106.6652374,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C 367 \u0110INH B\u1ED8 L\u0128NH",
        "367 \u0110inh B\u1ED9 L\u0129nh, Ph\u01B0\u1EDDng 26, Qu\u1EADn B\xecnh Th\u1EA1nh",
        10.815295,
        106.7078167,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C 486A L\xca V\u0102N L\u01AF\u01A0NG",
        "486A L\xea V\u0103n L\u01B0\u01A1ng, P. T\xe2n Phong, Q.7, HCM",
        10.7351687,
        106.6998548,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C 51A PHAN \u0110\u0102NG L\u01AFU",
        "51A Phan \u0110\u0103ng L\u01B0u, Ph\u01B0\u1EDDng 7, Qu\u1EADn Ph\xfa Nhu\u1EADn, HCM",
        10.8033977,
        106.6869716,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C 973 L\u0168Y B\xc1N B\xcdCH",
        "973 L\u0168Y B\xc1N B\xcdCH, P. T\xc2N TH\xc0NH, T\xc2N PH\xda, HCM",
        10.792504,
        106.6349632,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C B\u1EBEN XE NG\xc3 T\u01AF GA",
        "720 qu\u1ED1c l\u1ED9 1A, ph\u01B0\u1EDDng Th\u1EA1nh L\u1ED9c, qu\u1EADn 12, HCM",
        10.8692239,
        106.650881,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C BX AN S\u01AF\u01A0NG",
        "B\u1EBFn Xe An S\u01B0\u01A1ng, QL 22, B\xe0 \u0110i\u1EC3m, H\xf3c M\xf4n, TP.HCM",
        10.8444242,
        106.6100214,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C BX MI\u1EC0N \u0110\xd4NG",
        "292 \u0110inh B\u1ED9 L\u0129nh, P.26, Q.B\xecnh Th\u1EA1nh, TP.HCM",
        10.8146279,
        106.7080328,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C BX MI\u1EC0N T\xc2Y",
        "395 Kinh D\u01B0\u01A1ng V\u01B0\u01A1ng. P. An L\u1EA1c A. Qu\u1EADn B\xecnh T\xe2n - B\xe3i tr\u1EA3 kh\xe1ch",
        10.7406653,
        106.6132549,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C BXM\u0110 (M\u1EDAI)",
        "501 \u0111\u01B0\u1EDDng Ho\xe0ng H\u1EEFu Nam, ph\u01B0\u1EDDng Long B\xecnh, Th\xe0nh ph\u1ED1 Th\u1EE7 \u0110\u1EE9c",
        10.8546666,
        106.7157521,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C \u0110H B\xc1CH KHOA",
        "6B \u0110\u01B0\u1EDDng s\u1ED1 02 C\u01B0 X\xe1 L\u1EEF Gia, Ph\u01B0\u1EDDng 15, Qu\u1EADn 11, HCM",
        10.7723109,
        106.6543853,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C H\xc0NG XANH",
        "486H - 486J \u0110i\u1EC7n Bi\xean Ph\u1EE7, Ph\u01B0\u1EDDng 21, Qu\u1EADn B\xecnh Th\u1EA1nh, TP. HCM",
        10.8010127,
        106.7074942,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C NG\xc3 4 B\xccNH PH\u01AF\u1EDAC",
        "S\u1ED1 136, Qu\u1ED1c l\u1ED9 1A, KP4, Tam B\xecnh, Th\u1EE7 \u0110\u1EE9c, TP.HCM",
        10.8673286,
        106.7260825,
        1
    ],
    [
        "H\u1ED3 Ch\xed Minh",
        "B\u01AFU C\u1EE4C XA L\u1ED8 H\xc0 N\u1ED8I",
        "800  \u0110\u01B0\u1EDDng QL 52, KP 3, Ph\u01B0\u1EDDng Hi\u1EC7p Ph\xfa, Qu\u1EADn 9, Tp. HCM",
        10.8508795,
        106.767294,
        1
    ],
    [
        "L\xc2M \u0110\u1ED2NG",
        "B\u01AFU C\u1EE4C B\u1EA2O L\xc2M - L\xc2M \u0110\u1ED2NG",
        "95 Tr\u1EA7n Ph\xfa -TT L\u1ED9c Th\u1EAFng -Huy\u1EC7n B\u1EA3o L\xe2m-T\u1EC9nh L\xe2m \u0110\u1ED3ng",
        11.6317737,
        107.8343966,
        1
    ],
    [
        "L\xc2M \u0110\u1ED2NG",
        "B\u01AFU C\u1EE4C B\u1EA2O L\u1ED8C - L\xc2M \u0110\u1ED2NG",
        "399 Tr\u1EA7n Ph\xfa P.L\u1ED9c S\u01A1n, TP.B\u1EA3o L\u1ED9c, T\u1EC9nh L\xe2m \u0110\u1ED3ng",
        11.5366042,
        107.8122879,
        1
    ],
    [
        "L\xc2M \u0110\u1ED2NG",
        "B\u01AFU C\u1EE4C B\u1EBEN XE \u0110\xc0 L\u1EA0T",
        "S\u1ED1 1 T\xf4 Hi\u1EBFn Th\xe0nh. Ph\u01B0\u1EDDng 3. TP \u0110\xe0 l\u1EA1t. T\u1EC9nh L\xe2m \u0110\u1ED3ng",
        11.9264194,
        108.4434422,
        1
    ],
    [
        "L\xc2M \u0110\u1ED2NG",
        "B\u01AFU C\u1EE4C DI LINH",
        "B\u1EBFn xe Di Linh, \u0110\u01B0\u1EDDng H\xf9ng V\u01B0\u01A1ng, Th\u1ECB Tr\u1EA5n Di Linh, T\u1EC9nh L\xe2m \u0110\u1ED3ng",
        11.5904234,
        108.0732091,
        1
    ],
    [
        "L\xc2M \u0110\u1ED2NG",
        "B\u01AFU C\u1EE4C \u0110\u1EE8C TR\u1ECCNG",
        "795 Qu\u1ED1c L\u1ED9 20,th\u1ECB tr\u1EA5n Li\xean ngh\u0129a,Huy\u1EC7n \u0110\u1EE9c Tr\u1ECDng,T\u1EC9nh L\xe2m \u0110\u1ED3ng",
        11.7239716,
        108.3577151,
        1
    ],
    [
        "L\xc2M \u0110\u1ED2NG",
        "B\u01AFU C\u1EE4C LANGBIANG - L\xc2M \u0110\u1ED2NG",
        "S\u1ED1 03 LangBiang, Th\u1ECB tr\u1EA5n L\u1EA1c D\u01B0\u01A1ng, Huy\u1EC7n L\u1EA1c D\u01B0\u01A1ng, T\u1EC9nh L\xe2m \u0110\u1ED3ng",
        12.0140372,
        108.4200275,
        1
    ],
    [
        "L\xc2M \u0110\u1ED2NG",
        "B\u01AFU C\u1EE4C L\xca QU\xdd \u0110\xd4N - \u0110\xc0 L\u1EA0T",
        "11A/2 L\xea Qu\xfd \u0110\xf4n, P.5, TP.\u0110\xe0 L\u1EA1t, T\u1EC9nh L\xe2m \u0110\u1ED3ng",
        11.9412629,
        108.4286641,
        1
    ],
    [
        "L\xc2M \u0110\u1ED2NG",
        "B\u01AFU C\u1EE4C NGUY\u1EC4N C\xd4NG TR\u1EE8 \u0110\xc0 L\u1EA0T",
        "02 Nguy\u1EC5n C\xf4ng Tr\u1EE9, Ph\u01B0\u1EDDng 2, TP. \u0110\xe0 L\u1EA1t, T\u1EC9nh L\xe2m \u0110\u1ED3ng",
        11.9484987,
        108.4222033,
        1
    ],
    [
        "L\xc2M \u0110\u1ED2NG",
        "B\u01AFU C\u1EE4C TH\u1EA0NH M\u1EF8",
        "S\u1ED1 44, \u0110\u01B0\u1EDDng 2/4, Khu ph\u1ED1 Ngh\u0129a \u0110\u1EE9c, TT. Th\u1EA1nh M\u1EF9, H. \u0110\u01A1n D\u01B0\u01A1ng, T\u1EC9nh L\xe2m \u0110\u1ED3ng",
        11.7622545,
        108.5006016,
        1
    ],
    [
        "L\xc2M \u0110\u1ED2NG",
        "B\u01AFU C\u1EE4C TR\u1EA0I M\xc1T - \u0110\xc0 L\u1EA0T",
        "S\u1ED1 07 T\u1EF1 Ph\u01B0\u1EDBc, Ph\u01B0\u1EDDng 11, TP. \u0110\xe0 L\u1EA1t, T\u1EC9nh L\xe2m \u0110\u1ED3ng",
        11.944475,
        108.498796,
        1
    ],
    [
        "NAM \u0110\u1ECANH",
        "B\u01AFU C\u1EE4C NAM \u0110\u1ECANH",
        "B\u1EBFn xe kh\xe1ch Nam \u0110\u1ECBnh, KM2, \u0110\u01B0\u1EDDng \u0110i\u1EC7n Bi\xean, Ph\u01B0\u1EDDng L\u1ED9c H\xf2a, TP. Nam \u0110\u1ECBnh",
        20.433614,
        106.1274401,
        1
    ],
    [
        "NINH THU\u1EACN",
        "B\u01AFU C\u1EE4C BX PHAN RANG",
        "BX kh\xe1ch Ninh Thu\u1EADn, \u0110\u01B0\u1EDDng L\xea Du\u1EA9n, \u0110\xe0i S\u01A1n, Phan Rang - Th\xe1p Ch\xe0m",
        11.5849143,
        108.9849008,
        1
    ],
    [
        "NINH THU\u1EACN",
        "B\u01AFU C\u1EE4C PH\xda QU\xdd - NINH THU\u1EACN",
        "S\u1ED1 118 \u0110\u01B0\u1EDDng QL1A, Th\u1ECB Tr\u1EA5n Ph\u01B0\u1EDBc D\xe2n, T\u1EC9nh Ninh Thu\u1EADn",
        11.5235303,
        108.9240998,
        1
    ],
    [
        "PH\xda Y\xcaN",
        "B\u01AFU C\u1EE4C 77 L\xca L\u1EE2I",
        "77 L\xea L\u1EE3i, P.3, TP.Tuy H\xf2a, Ph\xfa Y\xean",
        13.0875194,
        109.2991399,
        1
    ],
    [
        "PH\xda Y\xcaN",
        "B\u01AFU C\u1EE4C BX PH\xcdA NAM PH\xda Y\xcaN",
        "507 Nguy\u1EC5n V\u0103n Linh, P.Ph\xfa L\xe2m, TP.Tuy H\xf2a",
        13.0407141,
        109.3092346,
        1
    ],
    [
        "QU\u1EA2NG NAM",
        "B\u01AFU C\u1EE4C NAM PH\u01AF\u1EDAC - QU\u1EA2NG NAM",
        "BX Nam Ph\u01B0\u1EDBc, TT.Nam Ph\u01B0\u1EDBc, H.Duy Xuy\xean",
        15.8385768,
        108.2817195,
        1
    ],
    [
        "QU\u1EA2NG NAM",
        "B\u01AFU C\u1EE4C TAM K\u1EF2 - QU\u1EA2NG NAM",
        "252 Nguy\u1EC5n Ho\xe0ng, Ph\u01B0\u1EDDng An S\u01A1n, TP.Tam K\u1EF3",
        15.5555515,
        108.4865288,
        1
    ],
    [
        "QU\u1EA2NG NG\xc3I",
        "B\u01AFU C\u1EE4C QU\u1EA2NG NG\xc3I",
        "2 Tr\u1EA7n Kh\xe1nh D\u01B0, P.Ngh\u0129a Ch\xe1nh, TP Qu\u1EA3ng Ng\xe3i, T\u1EC9nh Qu\u1EA3ng Ng\xe3i",
        15.1149374,
        108.8093541,
        1
    ],
    [
        "S\xd3C TR\u0102NG",
        "B\u01AFU C\u1EE4C AN TR\u1EA0CH",
        "720 QL1A \u1EA5p An Tr\u1EA1ch, x\xe3 An Hi\u1EC7p, huy\u1EC7n Ch\xe2u Th\xe0nh, t\u1EC9nh S\xf3c Tr\u0103ng",
        9.6510436,
        105.9361829,
        1
    ],
    [
        "S\xd3C TR\u0102NG",
        "B\u01AFU C\u1EE4C NG\xc3 N\u0102M",
        "B\u1EBFn Xe Ng\xe3 N\u0103m, S\u1ED1 76 \u0110\u01B0\u1EDDng Nguy\u1EC5n Tr\xe3i, Kh\xf3m 3, Ph\u01B0\u1EDDng 1, TX Ng\xe3 N\u0103m, t\u1EC9nh S\xf3c Tr\u0103ng",
        9.5604027,
        105.606969,
        1
    ],
    [
        "S\xd3C TR\u0102NG",
        "B\u01AFU C\u1EE4C S\xd3C TR\u0102NG",
        "38 L\xea Du\u1EA9n, P.3, TP.S\xf3c Tr\u0103ng, t\u1EC9nh S\xf3c Tr\u0103ng",
        9.594357,
        105.9716287,
        1
    ],
    [
        "TI\u1EC0N GIANG",
        "B\u01AFU C\u1EE4C M\u1EF8 THO",
        "212 Tr\u1EA7n H\u01B0ng \u0110\u1EA1o, Ph\u01B0\u1EDDng 4, TP M\u1EF9 Tho, t\u1EC9nh Ti\u1EC1n Giang",
        10.3560386,
        106.3221707,
        1
    ],
    [
        "TI\u1EC0N GIANG",
        "B\u01AFU C\u1EE4C SA TRA",
        "\u1EA4p H\xf2a Ph\xfac, X.H\xf2a Kh\xe1nh, H.C\xe1i B\xe8, t\u1EC9nh Ti\u1EC1n Giang",
        10.3590366,
        105.8395245,
        1
    ],
    [
        "TI\u1EC0N GIANG",
        "B\u01AFU C\u1EE4C TH\xc2N C\u1EECU NGH\u0128A - TI\u1EC0N GIANG",
        "\u0110\u01B0\u1EDDng t\u1EC9nh 878,  \u1EA4p 1, X\xe3 Tam Hi\u1EC7p, Huy\u1EC7n Ch\xe2u Th\xe0nh, T\u1EC9nh Ti\u1EC1n Giang ( C\xe2y x\u0103ng 19  Th\xe2n C\u1EEDu Ngh\u0129a)",
        10.4240354,
        106.3167177,
        1
    ],
    [
        "TR\xc0 VINH",
        "B\u01AFU C\u1EE4C B\u1EBEN XE TR\xc0 VINH",
        "559 QL54, Kh\xf3m 4, P.9, TP.Tr\xe0 Vinh, t\u1EC9nh Tr\xe0 Vinh",
        9.891256,
        106.3020377,
        1
    ],
    [
        "TR\xc0 VINH",
        "B\u01AFU C\u1EE4C B\xccNH PH\xda",
        "\u1EA4p Nguy\u1EC7t L\xe3ng A, X.B\xecnh Ph\xfa, H.C\xe0ng Long, t\u1EC9nh Tr\xe0 Vinh",
        9.9630309,
        106.2413939,
        1
    ],
    [
        "TR\xc0 VINH",
        "B\u01AFU C\u1EE4C BX DUY\xcaN H\u1EA2I - TR\xc0 VINH",
        "\u0111\u01B0\u1EDDng 19 th\xe1ng 5, kh\xf3m 1, ph\u01B0\u1EDDng 1, th\u1ECB x\xe3 Duy\xean H\u1EA3i, Tr\xe0 Vinh",
        9.6346434,
        106.4912174,
        1
    ],
    [
        "TR\xc0 VINH",
        "B\u01AFU C\u1EE4C TR\xc0 VINH",
        "27 Nguy\u1EC5n \u0110\xe1ng, Kh\xf3m 1, P.7, TP.Tr\xe0 Vinh, t\u1EC9nh Tr\xe0 Vinh",
        9.9259058,
        106.3320948,
        1
    ],
    [
        "V\u0128NH LONG",
        "B\u01AFU C\u1EE4C B\xccNH MINH",
        "\u1EA4p Thu\u1EADn Ti\u1EBFn B, X.Thu\u1EADn An, TX.B\xecnh Minh, V\u0129nh Long",
        10.0752712,
        105.8389778,
        1
    ],
    [
        "V\u0128NH LONG",
        "B\u01AFU C\u1EE4C BX V\u0128NH LONG",
        "1E \u0110inh Ti\xean Ho\xe0ng, P.8, TP.V\u0129nh Long",
        10.2384081,
        105.954894,
        1
    ],
    [
        "V\u0128NH LONG",
        "B\u01AFU C\u1EE4C SONG PH\xda",
        "L\xf4 A27-29, Song Ph\xfa m\u1EDBi, \u1EA4p Ph\xfa Ninh, X.Song Ph\xfa, H.Tam B\xecnh, V\u0129nh Long",
        10.117544414982738,
        105.90160202084256,
        1
    ],
    [
        "V\u0128NH LONG",
        "B\u01AFU C\u1EE4C TR\xc0 \xd4N",
        "B\u1EBFn xe Tr\xe0 \xd4n, T\u1ED5 6, Khu 7, Th\u1ECB Tr\u1EA5n Tr\xe0 \xd4n, Huy\u1EC7n Tr\xe0 \xd4n, T\u1EC9nh V\u0129nh Long.",
        9.9705978,
        105.9221828,
        1
    ]
];
async function $35da740d59af89ba$var$initMap() {
    const position = {
        lat: 16.789516,
        lng: 106.583847
    }; // Quang Tri - Center of VN
    const { Map: Map, InfoWindow: InfoWindow } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement: AdvancedMarkerElement, PinElement: PinElement } = await google.maps.importLibrary("marker");
    // The map, Quang Tri - Center of VN
    $35da740d59af89ba$var$map = new Map(document.getElementById("map"), {
        zoom: 6,
        center: position,
        mapId: "7ba16be0c9375fa7"
    });
    const featureLayer = $35da740d59af89ba$var$map.getFeatureLayer(google.maps.FeatureType.ADMINISTRATIVE_AREA_LEVEL_1);
    featureLayer.style = (featureStyleFunctionOptions)=>{
        const placeFeature = featureStyleFunctionOptions.feature;
        const population = $35da740d59af89ba$var$provinces[placeFeature.placeId];
        let fillColor, fillOpacity;
        if (population > 0) {
            fillColor = "#ef5222"; // Futa color
            fillOpacity = 0.5;
        } else if (population == 0) {
            fillColor = "green";
            fillOpacity = 0.4;
        }
        return {
            fillColor: fillColor,
            fillOpacity: fillOpacity
        };
    };
    const infoWindow = new InfoWindow();
    for(let i = 0; i < $35da740d59af89ba$var$post_offices.length; i++){
        const pin = new PinElement({
            glyph: `${i + 1}`,
            scale: 1.5
        });
        const marker = new AdvancedMarkerElement({
            map: $35da740d59af89ba$var$map,
            position: {
                lat: $35da740d59af89ba$var$post_offices[i][3],
                lng: $35da740d59af89ba$var$post_offices[i][4]
            },
            // title: post_offices[i][1],
            gmpClickable: true
        });
        marker.addListener("click", ({ domEvent: domEvent, latLng: latLng })=>{
            // const { target } = domEvent;
            const content = `
      <div style="padding: 8px">
        <h2 style="margin-top: 0">${$35da740d59af89ba$var$post_offices[i][0]}</h2>
        <h3>${$35da740d59af89ba$var$post_offices[i][1]}</h3>
        <p>${$35da740d59af89ba$var$post_offices[i][2]}</p>
      </div>
    `;
            infoWindow.close();
            infoWindow.setContent(content);
            infoWindow.open(marker.map, marker);
        });
    }
}
$35da740d59af89ba$var$initMap();


//# sourceMappingURL=index.8c94dad3.js.map
